import BillingGridBuilder from './BillingGridBuilder';
import BillingGridFootnotes from './BillingGridFootnotes';
import BillingGridReviewForm from './BillingGridReviewForm';

const BillingGridTabs = ({
	billingGridObject,
	onRequestReview,
	studyId,
	studyStatus
}) => {
	const footnotes = billingGridObject.footnotes
		? billingGridObject.footnotes
		: '';
	return (
		<>
			<ul className='nav' data-tour='billing-grid-tables'>
				{billingGridObject.map((billingGridTable, i) => {
					return (
						<li className='nav-item' key={i}>
							<a className='nav-link'>
								<h6>Section {i + 1}</h6>
								<BillingGridBuilder
									onRequestReview={onRequestReview}
									billingGridData={billingGridTable}
									tableNumber={i}
									studyId={studyId}
									studyStatus={studyStatus}
								/>
							</a>
						</li>
					);
				})}
			</ul>
			{footnotes && (
				<BillingGridFootnotes footnotes={footnotes} />
			)}
			<BillingGridReviewForm />
		</>
	);
};

export default BillingGridTabs;
